module.exports = __webpack_public_path__ + "img/LR.d5d14aeb.svg";